import { InstallableApp, Skill } from 'client/model/skill';

export const getAppHeader = (app: InstallableApp | Skill) => (app.onAir ? app.name : app.draft.name);
